export function getCurrentLocation(successCallback, errorCallback) {
  if ("geolocation" in navigator) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        successCallback({ latitude, longitude });
      },
      (error) => {
        if (errorCallback) {
          errorCallback(error);
        } else {
          console.error("Error getting location:", error.message);
        }
      },
      {
        enableHighAccuracy: true, // Better accuracy (uses GPS if available)
        timeout: 10000,           // Max wait time (10 seconds)
        maximumAge: 0             // No cached location
      }
    );
  } else {
    console.error("Geolocation is not supported by this browser.");
    if (errorCallback) errorCallback(new Error("Geolocation not supported"));
  }
}
